<template>
	<v-dialog persistent v-model="dialog" width="800px">
		<v-card>
			<v-card-title>
			</v-card-title>
			<v-card-text class="py-0">
				<v-carousel v-if="item && item.pathologyReports" style="max-height:100%;border:1px solid #ccc;" height="60vh" hide-delimiters>
					<v-carousel-item v-for="(pr, i) in item.pathologyReports" :key="i">
						<div style="overflow-y:auto;height:100%;">
							<img :src="pr" style="display:block;width:100%;"/>
						</div>
					</v-carousel-item>
				</v-carousel>
				<v-form ref="pdform" class="d-flex" style="column-gap: 12px;">
					<v-textarea label="胃镜病理" placeholder="请输入胃镜病理诊断" rows="4" outlined class="mt-4" hide-details v-model.trim="pathologyDiagnosisW"/>
					<v-textarea label="肠镜病理" placeholder="请输入肠镜病理诊断" rows="4" outlined class="mt-4" hide-details v-model.trim="pathologyDiagnosisC"/>
				</v-form>
			</v-card-text>
			<v-card-actions class="pt-2 pb-4">
				<v-spacer/>
				<v-btn color="primary" @click.stop="save" :loading="saving" :disabled="saving">保存</v-btn>
				<v-btn @click.stop="exitDlg">返回</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: 'PathologyInput',
		props: {
			value: false,
			item: {},
		},
		data() {
			return {
				saving: false,
				pathologyDiagnosisW: '',
				pathologyDiagnosisC: '',
			}
		},
		computed: {
			dialog: {
				get() {
					return this.value;
				},
				set(v) {
					if (!v) {
						this.$emit('input', false);
					}
				}
			},
		},
		watch: {
			value(v) {
				if (v) {
					this.pathologyDiagnosisW = this.item?.pathologyDiagnosisW || '';
					this.pathologyDiagnosisC = this.item?.pathologyDiagnosisC || '';
				}
			}
		},
		methods: {
			exitDlg() {
				this.dialog = false;
				this.$emit('close');
			},
			async save() {
				if (!this.$refs.pdform.validate()) return;
				const id = this.item._id;
				const pathologyDiagnosisW = this.pathologyDiagnosisW;
				const pathologyDiagnosisC = this.pathologyDiagnosisC;
                this.saving = true;
				try {
					await this.$tcbapp.callFunction({name:"wp2mp", data:{funcname:'savePathologyDiagnosis', data:{id, pathologyDiagnosisW, pathologyDiagnosisC}}});
					this.$set(this.item, 'pathologyDiagnosisW', pathologyDiagnosisW);
					this.$set(this.item, 'pathologyDiagnosisC', pathologyDiagnosisC);
					this.$dialog.message.success('保存成功');
				} catch(err) {
					console.error(err);
					this.$dialog.message.error('保存失败');
				}
                this.saving = false;
			},
		}
	}
</script>

